import { useState } from 'react'
import { AppSection } from './components/AppSection/AppSection'
import { DocumentMeta } from './components/DocumentMeta/DocumentMeta'
import { Faq } from './components/Faq/Faq'
import { Footer } from './components/Footer/Footer'
import { Header } from './components/Header/Header'
import { Hero } from './components/Hero/Hero'
import { HowItWorksModal } from './components/HowItWorksModal/HowItWorksModal'
import { PromoBanner } from './components/PromoBanner/PromoBanner'
import { PromoCodeModal } from './components/PromoCodeModal/PromoCodeModal'
import { SendGrid } from './components/SendGrid/SendGrid'
import { Steps } from './components/Steps/Steps'
import { WhyGrid } from './components/WhyGrid/WhyGrid'
import { useLanguageSync } from './hooks/useLanguage'

type ActiveModal = 'how-it-works' | 'promo-code' | null

const App = () => {
  useLanguageSync()
  const [activeModal, setActiveModal] = useState<ActiveModal>(null)

  const openPromo = () => {
    setActiveModal('promo-code')
  }
  const openHowItWorks = () => {
    setActiveModal('how-it-works')
  }
  const closeModal = () => {
    setActiveModal(null)
  }

  return (
    <>
      <DocumentMeta />
      <Header onGetPromo={openPromo} />
      <main>
        <Hero onGetPromo={openPromo} />
        <Steps onSend={openHowItWorks} />
        <AppSection />
        <WhyGrid onSend={openHowItWorks} />
        <PromoBanner onGetPromo={openPromo} />
        <SendGrid />
        <Faq />
      </main>
      <Footer />
      {activeModal === 'promo-code' && (
        <PromoCodeModal onClose={closeModal} onHowItWorks={openHowItWorks} />
      )}
      {activeModal === 'how-it-works' && (
        <HowItWorksModal onClose={closeModal} onGetPromo={openPromo} />
      )}
    </>
  )
}

export default App
